class LoadMore extends HTMLElement {
  constructor(){
    super();

    this.button = this.querySelector('button');
    if (!this.button) return;

    this.button.addEventListener('click', (e) => {
      this.getNextPage(e);
    });
  }

  async getNextPage(e) {
    const self = e.target;
    const url = self.dataset.nextUrl;

    const selector = 'main-collection-product-grid';
    const container = document.getElementById(selector);

    if (!url) {
      this.hideContent();
    }

    self.classList.add('working');

    try {
      const res = await fetch(url);
      const data = await res.text();

      if (res.ok) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");

        const products = doc.querySelectorAll('.collection .product-item');
        container.append(...products);

        const current = doc.querySelector('load-more button');
        if (current && current.dataset.nextUrl)
          self.dataset.nextUrl = current.dataset.nextUrl;
        else
          this.hideContent()

        document.dispatchEvent(new CustomEvent('plpLoadMore:success'));
      }
    } catch (error) {
      console.log(error);
      this.hideContent();
    } finally {
      self.classList.remove('working');
    }
  }

  hideContent() {
    this.classList.add('hide');
    return;
  }
}
if (!customElements.get('load-more')){
  customElements.define('load-more', LoadMore);
}